export const LANDING_FAQ_GENERAL_QUESTION_KEYS = [
  'audience',
  'aiAgentGuide',
  'benefits',
  'questionTypes',
  'chatGptDifference',
  'reliability',
  'humanExpertise',
  'dataProtection',
] as const;

export const LANDING_FAQ_PAID_QUESTION_KEYS = [
  'pricing',
  'pricingReason',
  'trialCard',
  'trialEnd',
] as const;

export const LANDING_FAQ_QUESTION_KEYS = [
  ...LANDING_FAQ_GENERAL_QUESTION_KEYS,
  ...LANDING_FAQ_PAID_QUESTION_KEYS,
] as const;

export type LandingFaqQuestionKey = (typeof LANDING_FAQ_QUESTION_KEYS)[number];

export const LANDING_FAQ_CREDIT_OPTION_KEYS = ['renewal', 'subscription', 'pack'] as const;

export const LANDING_FAQ_QUESTION_TYPE_KEYS = [
  'exemptions',
  'unObligations',
  'packagingMarkingPlacarding',
  'equipmentVehicles',
  'loadingTrafficRestrictions',
  'transportThresholds',
  'tanksPackagingsInstructions',
  'adrTunnels',
  'generalDangerousGoods',
] as const;
